// extracted by mini-css-extract-plugin
export default {"broking_link":"notfound_broking_link__pebiy","error":"notfound_error__uWSUD"};